export default __webpack_public_path__ + "static/media/videoplayer_wrap.576eb153.png";